import React from "react";
import { View, Form, Text } from "@adobe/react-spectrum";
import PropTypes from "prop-types";

export default function ViewExtendedAttributesForm(props) {
  const { data, labels, groupKeys } = props;
  const style = { color: "#4B4B4B", fontSize: "1rem" };

  return (
    <Form UNSAFE_style={{ backgroundColor: "#F5F5F5" }}>
      {labels.map((item) => (
        <View key={item.key} marginBottom={14}>
          <Text UNSAFE_style={{ color: "#707070", fontSize: "0.82rem" }}>
            {item.title}
          </Text>
          <View>
            <Text UNSAFE_style={style}>
              {item.key === "group_description"
                ? groupKeys.find((attr) => attr.group_key === data.group_key)
                    .group_description
                : data[item.key]}
            </Text>
          </View>
        </View>
      ))}
    </Form>
  );
}

ViewExtendedAttributesForm.propTypes = {
  data: PropTypes.objectOf(
    PropTypes.oneOfType(
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any))
    )
  ).isRequired,
  labels: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, key: PropTypes.string })
  ).isRequired,
  groupKeys: PropTypes.arrayOf(
    PropTypes.shape({
      group_key: PropTypes.string,
      group_description: PropTypes.string,
    })
  ).isRequired,
};
